import React, {FC} from "react"
import {Deal} from "@irati/types"
import styled from "styled-components"
import {useTheme} from "@irati/ui/src/global/useTheme"
import Pill from "@irati/ui/src/Pill"
import {FormattedMessage} from "@irati/utils/lang"
import {DealTypeLabel, getDealTypeLabel} from "@irati/deals/helpers/deals/determineDealType"

interface Props {
  deal: Deal
}

const DealTypePill: FC<Props> = ({deal}) => {
  const theme = useTheme()
  const type = getDealTypeLabel(deal)

  switch (type) {
    case DealTypeLabel.FLEXI_PERK:
      return (
        <HoverWhiteColorWrapper>
          <Pill
            text={<FormattedMessage id="platform.deals.dealType.fp" />}
            backgroundColor={theme.colors.tertiary.i_400}
            fontSize="12px"
            isWhiteText
          />
        </HoverWhiteColorWrapper>
      )
    case DealTypeLabel.PHYSICAL_GIFT:
      return (
        <HoverWhiteColorWrapper>
          <Pill
            text={<FormattedMessage id="platform.deals.dealType.merchandise" />}
            backgroundColor={theme.colors.tertiary.p_400}
            fontSize="12px"
            isWhiteText
          />
        </HoverWhiteColorWrapper>
      )
    case DealTypeLabel.CASHBACK:
      return (
        <Pill
          text={<FormattedMessage id="platform.deals.dealType.cashback" />}
          backgroundColor={theme.colors.tertiary.y_400}
          fontSize="12px"
        />
      )
    case DealTypeLabel.COMPETITION:
      return (
        <Pill
          text={<FormattedMessage id="platform.deals.dealType.competition" />}
          backgroundColor={theme.colors.tertiary.p_200}
          fontSize="12px"
        />
      )
    case DealTypeLabel.GIFT_CARD:
      return (
        <Pill
          text={<FormattedMessage id="platform.deals.dealType.giftCard" />}
          backgroundColor={theme.colors.tertiary.v_200}
          fontSize="12px"
        />
      )
    default:
      return null
  }
}

const HoverWhiteColorWrapper = styled.div`
  &:hover span {
    span {
      color: ${({theme}) => theme.colors.greys.white};
    }
  }
`

export default DealTypePill
